export const translations = {
	welcome_paragraph: {
		en: "I'm a student from Czech Republic and I enjoy everything from programming and math, to sports and hiking. Feel free to read about <projects>my projects</projects> :)",
		cs: "Jsem student a baví mě všechno od programování a matematiky po sport a procházky přírodou. Můžete si přečíst o <projects>mých projektech</projects> :)",
	},

	switch_language: {
		en: "Switch language",
		cs: "Změnit jazyk",
	},

	my_projects_placeholder_paragraph: {
		en: "You will find all my projects here in the future :)",
		cs: "Zde v budoucnu najdete všechny mé projekty :)",
	},

	my_projects_navlink: {
		en: "My projects",
		cs: "Mé projekty",
	},

	my_projects_powertown_paragraph: {
		en: "This project began as a topic for a Czech high-school student competition called <spa>SPA</spa>. After some early success, I decided to continue developing it independently and explore its full potential. PowerTown is a 2D strategy game with an educational potential written in C# using the <monogame>MonoGame</monogame> framework. It places the player in the role of a newly appointed mayor. Their task is to save the town from severe pollution caused by its own power plants while still maintaining a stable energy supply. The player can reorganize the grid by building new plants or decommissioning old ones, with a twist: the game's currency is time, and every action moves the clock forward. The project is currently under development, with a first early version available for <download>Windows</download> in .zip format.",
		cs: "Tento projekt původně vznikl jako téma pro <spa>Středoškolskou odbornou činnost</spa>. Navzdory počátečnímu úspěchu jsem se rozhodl, že budu s vývojem pokračovat nezávisle a pokusím se prozkoumat jeho plný potenciál. PowerTown je 2D strategická hra se vzdělávacím potenciálem, napsaná v C# s pomocí frameworku <monogame>MonoGame</monogame>. Umisťuje hráče do role nově zvoleného starosty. Jeho úkolem je uchránit město před narůstajícím znečištěním, způsobeným jeho vlastními elektrárnami, aniž by narušil stabilní dodávky energie. Hráč může přeorganizovat elektrickou síť stavbou nových, nebo odstávkou starých elektráren. Má to ale háček: herní měnou je čas a každé rozhodnutí posouvá hodiny vpřed. Projekt je momentálně ve vývoji, s dostupnou první ranou verzí ke stažení ve formátu .zip pro <download>Windows</download>.",
	},

	my_projects_jumpqueen_paragraph: {
		en: "This 2D platformer is the result of my first and so far only attempt at desktop game development using the <unity>Unity</unity> game engine. Although the development process is much faster with it than working with just a framework like MonoGame, I found that it also takes away some of the satisfaction that comes from building everything purely through code. The game is inspired by the classic platformer <em>Jump King</em> and is currently complete and available for download in .zip format for <downloadwin>Windows</downloadwin> or <downloadmac>Mac OS</downloadmac>.",
		cs: "Tato 2D skákačka je výsledkem mého prvního a prozatím jediného pokusu o vývoj desktopových her pomocí herního enginu <unity>Unity</unity>. Přestože je s jeho pomocí proces vývoje mnohem rychlejší než práce s pouhým frameworkem jako je MonoGame, zjistil jsem, že z něj ale zároveň plyne mnohem méně satisfakce, než z vývoje pomocí pouhého kódu. Hra je inspirována klasickou skákačkou <em>Jump King</em> a je momentálně dokončená a dostupná ke stažení ve formátu .zip pro <downloadwin>Windows</downloadwin> nebo <downloadmac>Mac OS</downloadmac>.",
	},

	my_projects_other_heading: {
		en: "Other projects",
		cs: "Další projekty",
	},

	my_projects_other_paragraph: {
		en: "Besides game development I also study neural networks and machine learning, web development and 3D modeling in <blender>Blender</blender>.",
		cs: "Mimo herní vývoj se také věnuji studiu neuronových sítí a strojového učení, web developmentu nebo 3D modelování v <blender>Blenderu</blender>.",
	},

	site_title: {
		en: "Dominik's Personal Website",
		cs: "Dominikova Osobní Stránka",
	},

	page_not_found: {
		en: "Page Not Found",
		cs: "Stránka Nenalezena",
	},
};

export const defaultLang = "en";
